import { defineComponent as _defineComponent } from 'vue';
import { TooltipRoot, useForwardPropsEmits } from "reka-ui";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Tooltip',
    props: {
        defaultOpen: { type: Boolean, required: false },
        open: { type: Boolean, required: false },
        delayDuration: { type: Number, required: false },
        disableHoverableContent: { type: Boolean, required: false },
        disableClosingTrigger: { type: Boolean, required: false },
        disabled: { type: Boolean, required: false },
        ignoreNonKeyboardFocus: { type: Boolean, required: false }
    },
    emits: ["update:open"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emits = __emit;
        const forwarded = useForwardPropsEmits(props, emits);
        const __returned__ = { props, emits, forwarded, get TooltipRoot() { return TooltipRoot; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
